import type { TRouterStatuses } from '../models/router';

/** Роуты перехода по экшенам авторизации */
export const ROUTER_STATUS: TRouterStatuses = {
    /** Роут перехода в экшен запроса кода подтверждения телефона */
    REQUEST_CODE: 'request_code',
    /** Роут перехода в экшен запроса верификации кода подтверждения */
    CONFIRM_CODE: 'confirm_code',
    /** Роут перехода в экшен возврата к экрану ввода телефона */
    START: 'start',
    /** Роут перехода в экшен повторной верификации кода при ретрае запроса */
    REQUEST_VERIFY_PHONE_CODE: 'request_verify_phone_code',
};

/** Статусы для отображения экранов ошибок */
export const STATUS_VIEW_ERRORS: Record<string, string> = {
    /** Некорректные данные */
    VALIDATION_ERROR: 'validationError',
    /** Ошибки сессии */
    TOKEN_NOT_SPECIFIED_ERROR: 'sessionTimeExpired',
    TOKEN_FORMAT_ERROR: 'sessionTimeExpired',
    TOKEN_EXPIRED_ERROR: 'sessionTimeExpired',
    TOKEN_VALIDATION_ERROR: 'sessionTimeExpired',
    /** Превышено количество попыток запроса нового кода за текущие сутки
     * для данного номера мобильного телефона и данного продукта*/
    RESPONSE_CODE_LIMIT_ERROR: 'tooMuchCodeVerification',
    /** Внутренняя ошибка сервиса */
    INTERNAL_SERVER_ERROR: 'technicalError',
    /** Необработанный кейс ошибки */
    TECHNICAL_ERROR: 'technicalError',
    /** Таймаут ожидания ответа от сервиса */
    GATEWAY_TIMEOUT: 'technicalError',
    /** Количество попыток исчерпано, статус код 429 */
    REQUEST_CODE_LIMIT_ERROR: 'tooMuchCodeVerification',
    /** Превышен лимит запроса кодов на верификацию, статус код 425 */
    REQUEST_NOT_ALLOWED: 'tooMuchCodeVerification',
};
